<template>
  <div class="download-client">
    <el-dialog
      title
      :visible.sync="dialogVisible"
      width="900px"
      :lock-scroll="false"
    >
      <p
        style="
          text-align: center;
          margin-bottom: 20px;
          font-size: 20px;
          font-weight: bolder;
        "
      >
        如果没有打开客户端请点击下载
      </p>
      <div style="text-align: center; padding: 30px 0px">
        <el-button
          type="danger"
          round
          style="width: 200px"
          @click="downloadClient('windows64')"
        >
          Windows64版下载
        </el-button>
        <el-button
          type="danger"
          round
          style="width: 200px"
          @click="downloadClient('windows32')"
        >
          Windows32版下载
        </el-button>
        <el-button
          type="danger"
          round
          style="width: 200px"
          @click="downloadClient('mac_intel')"
        >
          Mac版下载（Intel芯片）
        </el-button>
        <el-button
          type="danger"
          round
          style="width: 200px"
          @click="downloadClient('mac_apple')"
        >
          Mac版下载（Apple芯片）
        </el-button>
      </div>
    </el-dialog>
    <iframe
      v-if="iframeSrc"
      :src="iframeSrc"
      width="1"
      height="1"
      style="display: none"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "download-client",
  data() {
    return {
      iframeSrc: false,
      dialogVisible: false,
    };
  },
  created() {
    // 3秒后弹出下载提示框
    setTimeout(() => {
      this.dialogVisible = true;
    }, 3000);
    // 尝试打开客户端
    this.iframeSrc = this.$route.query.url;
  },
  methods: {
    //下载客户端
    downloadClient(type) {
      switch (type) {
        case "windows32":
          window.location.href = this.$store.state.commonSetting.win_download_url;
          break;
        case "windows64":
          window.location.href = this.$store.state.commonSetting.win_download_url_x64;
          break;
        case "mac_intel":
          window.location.href = this.$store.state.commonSetting.mac_download_url_intel;
          break;
        case "mac_apple":
          window.location.href = this.$store.state.commonSetting.mac_download_url_apple;
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/varibles.scss";
.download-client {
  .el-button--danger {
    background-color: $primary-color;
    border-color: $primary-color;
  }
}
</style>
